import React, {Component} from 'react';
const { connect } = require('react-redux');
import Modal from 'react-bootstrap-modal';
import Cropper from 'react-cropper';

import {t} from 'l10n';

import '../../sass/modals/modalChangeAvatar.scss';

import {uploadAvatarData} from '../../backend-helpers/member';
import {avatarChanged} from '../../reducers/member';

class ModalChangeAvatar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            src: ''
        };

        this.selectPhotoClick = this.selectPhotoClick.bind(this);
        this.onFileInputChange = this.onFileInputChange.bind(this);
        this.cropImage = this.cropImage.bind(this);

        this.onUploadAvatarDataSuccess = this.onUploadAvatarDataSuccess.bind(this);
    }

    selectPhotoClick(event) {
        event.preventDefault();

        this.fileInput.dispatchEvent(new MouseEvent('click', {}));
    }

    onFileInputChange(event) {
        event.preventDefault();

        let files;
        if (event.dataTransfer) {
            files = event.dataTransfer.files;
        } else if (event.target) {
            files = event.target.files;
        }

        const reader = new FileReader();
        reader.onload = () => {
            this.setState({src: reader.result});
        };
        reader.readAsDataURL(files[0]);
    }

    cropImage(event) {
        event.preventDefault();

        let canvas = this.cropper.getCroppedCanvas();

        if (typeof canvas === 'undefined') {
            return;
        }

        let avatarData = canvas.toDataURL('image/jpeg');

        // todo: maybe action dispatch (and update currentUser avatar url to avatarData value on success?

        uploadAvatarData(avatarData)
            .then(({avatar_url}) => this.onUploadAvatarDataSuccess(avatar_url))
            .catch(function(error) {
                console.log(error);
            });

        this.onHide();
    }

    onUploadAvatarDataSuccess(avatarUrl) {
        let {closeFn, avatarChanged} = this.props;

        avatarChanged(avatarUrl);
        closeFn();
    }

    onHide() {
        this.setState({src: null});
        this.props.closeFn();
    }

    render() {
        const {show} = this.props;

        const {src} = this.state;

        return (
            <div>
                <Modal className="modalchangeAvatar" show={show} onHide={() => this.onHide()}>
                    <Modal.Body>
                        <div className="close" onClick={() => this.onHide()}></div>
                        <p className="modal-title">{t('Change avatar')}</p>

                        <div className="form">
                            <input type="file" accept="image/jpeg" ref={(fileInput) => this.fileInput = fileInput} onChange={this.onFileInputChange}/>

                            {!src ?
                                <div className="form-group">
                                    <button className="select-photo" onClick={this.selectPhotoClick}>{t('Select photo')}</button>
                                </div>
                                :
                                <div className="form-group">
                                   <div className="edit-photo-block">
                                       <div className="img">
                                           <div className="icon-delete"></div>
                                           <Cropper
                                               style={{height: 256, width: '100%'}}
                                               viewMode={1}
                                               aspectRatio={4 / 3}
                                               preview=".img-preview"
                                               guides={false}
                                               src={this.state.src}
                                               ref={(cropper) => { this.cropper = cropper; }}
                                           />
                                       </div>
                                       <div className="preview">
                                           <h2>{t('Preview:')}</h2>
                                           <div className="img-preview" style={{}}/>
                                       </div>
                                   </div>
                                    <div className="edit-buttons">
                                        <button className="set-as-avatar" onClick={this.cropImage}>{t('Set as avatar')}</button>
                                        <button className="cancel" onClick={() => this.setState({src: ''})}>{t('Cancel')}</button>
                                    </div>
                               </div>
                            }
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

export default connect(null, {avatarChanged: avatarChanged})(ModalChangeAvatar);


// WEBPACK FOOTER //
// ./src/components/modals/ModalChangeAvatar.js